/* eslint-disable camelcase */
//
// Every component in this repository needs a uniquie identifier
// to be used with `react-css-themr`, this opens up the possibility
// for users of the UI to overide default css from the UI and
// create custom themes / components.
//
export default {
    badge: '@neos-project/react-ui-components/badge',
    bar: '@neos-project/react-ui-components/bar',
    button: '@neos-project/react-ui-components/button',
    buttonGroup: '@neos-project/react-ui-components/buttonGroup',
    checkBox: '@neos-project/react-ui-components/checkBox',
    dateInput: '@neos-project/react-ui-components/dateInput',
    dialog: '@neos-project/react-ui-components/dialog',
    dropDown: '@neos-project/react-ui-components/dropDown',
    dropDownContents: '@neos-project/react-ui-components/dropDownContents',
    dropDownHeader: '@neos-project/react-ui-components/dropDownHeader',
    frame: '@neos-project/react-ui-components/frame',
    grid: '@neos-project/react-ui-components/grid',
    gridItem: '@neos-project/react-ui-components/gridItem',
    headline: '@neos-project/react-ui-components/headline',
    icon: '@neos-project/react-ui-components/icon',
    iconButton: '@neos-project/react-ui-components/iconButton',
    iconButtonDropDown: '@neos-project/react-ui-components/iconButtonDropDown',
    label: '@neos-project/react-ui-components/label',
    listPreviewElement: '@neos-project/react-ui-components/listPreviewElement',
    multiSelectBox: '@neos-project/react-ui-components/multiSelectBox',
    multiSelectBox_ListPreviewSortable: '@neos-project/react-ui-components/multiSelectBox_ListPreviewSortable',
    multiSelectBox_ListPreviewSortable_DraggableListPreviewElement: '@neos-project/react-ui-components/multiSelectBox_ListPreviewSortable_DraggableListPreviewElement',
    selectBox: '@neos-project/react-ui-components/selectBox',
    selectBox_Header: '@neos-project/react-ui-components/selectBox_Header',
    selectBox_HeaderWithSearchInput: '@neos-project/react-ui-components/selectBox_HeaderWithSearchInput',
    selectBox_Option_MultiLineWithThumbnail: '@neos-project/react-ui-components/selectBox_Option_MultiLineWithThumbnail',
    sideBar: '@neos-project/react-ui-components/sideBar',
    tabs: '@neos-project/react-ui-components/tabs',
    tabsPanel: '@neos-project/react-ui-components/tabsPanel',
    textArea: '@neos-project/react-ui-components/textArea',
    textInput: '@neos-project/react-ui-components/textInput',
    toggablePanel: '@neos-project/react-ui-components/toggablePanel',
    toggablePanelContents: '@neos-project/react-ui-components/toggablePanelContents',
    toggablePanelHeader: '@neos-project/react-ui-components/toggablePanelHeader',
    tooltip: '@neos-project/react-ui-components/tooltip',
    tree: '@neos-project/react-ui-components/tree',
    treeNode: '@neos-project/react-ui-components/treeNode',
    treeNodeContents: '@neos-project/react-ui-components/treeNodeContents',
    treeNodeHeader: '@neos-project/react-ui-components/treeNodeHeader',
    treeDragLayer: '@neos-project/react-ui-components/treeDragLayer',
};
